import React, { useEffect } from "react";

const SegmentedControlResults = ({
    isActive,
    children,
    totalCount,
    totalItemsLoaded,
    firstBatchFetched,
    fetchFirstBatch,
    loadMore
}) => {
    useEffect(() => {
        if (isActive && !firstBatchFetched) fetchFirstBatch();
    }, [isActive]);

    const handleLoadMore = e => {
        e.preventDefault();
        loadMore();
    };

    const allItemsLoaded = totalItemsLoaded >= totalCount;
    const showLoadMoreButton = !allItemsLoaded && !!totalItemsLoaded;

    const content = (
        <>
            {children}
            {showLoadMoreButton && (
                <button onClick={handleLoadMore}>Load More</button>
            )}
        </>
    );

    return isActive ? content : null;
};

export default SegmentedControlResults;
